import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Team/Main";
import Form from "./Team/Form";

// Utils
import { getAlert, getData } from "../../../utils/SamuiUtils";
import { InitialDataTeam } from "../../../model/InitialData/InitialDataTeam";
import api from "../../../utils/axios";

const Team = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataEmployees, setDataEmployees] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataTeam());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const compId = window.localStorage.getItem("company");
      
      // ดึงข้อมูลทีม
      const teamsRes = await api.get(`/get-teams?Comp_Id=${compId}`);
      if (teamsRes.data?.status === "OK") {
        const teams = teamsRes.data.result || [];
        setDataMasterList(teams);
      }

      // ดึงข้อมูลพนักงานสำหรับเลือกหัวหน้าทีม
      // กรองเฉพาะพนักงานที่มีบทบาทเป็น "หัวหน้าทีม" (Role_Id = 4) เท่านั้น
      const empRes = await api.get(`/get-employees/${compId}`);
      if (empRes.data?.status === "OK") {
        let employees = empRes.data.result || [];
        
        // หัวหน้าทีม: บทบาท 4 = หัวหน้าช่าง, 3 = ช่าง (ให้เลือกได้ถ้ายังไม่มี role 4 ในระบบ)
        employees = employees.filter((emp) => {
          const empRole = emp.Emp_Role != null ? Number(emp.Emp_Role) : null;
          return empRole === 4 || empRole === 3;
        });
        
        setDataEmployees(employees);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      getAlert("FAILED", error.message || "ไม่สามารถโหลดข้อมูลได้");
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const formatThaiMobileNumber = (value) => {
    if (!value) return "";
    const digits = String(value).replace(/\D/g, "").slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      team_id: item.Team_Id,
      comp_id: item.Comp_Id,
      team_name: item.Team_Name || "",
      team_leader_id: item.Team_Leader_Id ? String(item.Team_Leader_Id) : "",
      team_color: item.Team_Color || "",
      vehicle_no: item.Vehicle_No || "",
      team_phone1: formatThaiMobileNumber(item.Team_Phone1),
      team_phone2: formatThaiMobileNumber(item.Team_Phone2),
      team_phone3: formatThaiMobileNumber(item.Team_Phone3),
      team_status: item.Team_Status || "A",
      team_username: item.Team_Username || "",
      team_password: item.Team_Password || "",
      team_pin: item.Team_Pin || "",
      auto_create_wh: item.Auto_Create_WH || false,
      team_members: (item.Team_Members || []).map((m) => ({
        member_name: m.Member_Name || "",
        member_phone: formatThaiMobileNumber(m.Member_Phone),
        member_username: m.Member_Username || "",
        member_password: m.Member_Password || "",
        member_pin: m.Member_Pin || "",
      })),
    });
    setSelectedData(item);
  };

  return (
    <div className="Team">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลทีม"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลทีม"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataEmployees={dataEmployees}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;

